export default __webpack_public_path__ + "static/media/EAST1070.34I-34192_-18437_0.24690275.jpg";